import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WholeSyncableFacilityFragment = { readonly __typename?: 'SyncableFacility', readonly id: string, readonly name: string, readonly organisation: string, readonly service?: string | null, readonly addresses: ReadonlyArray<{ readonly __typename?: 'Address', readonly country?: string | null, readonly state?: string | null, readonly street?: string | null, readonly subCounty?: string | null, readonly ward?: string | null }>, readonly settings: { readonly __typename?: 'ClinicSettings', readonly inventoryManagement: boolean }, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly updatedAt: string, readonly createdByUserId: string, readonly updatedByUserId: string, readonly deleted: boolean } };

export type SyncFacilityPullQueryVariables = Types.Exact<{
  input: Types.PullFacilityInput;
}>;


export type SyncFacilityPullQuery = { readonly __typename?: 'Query', readonly pullFacility: { readonly __typename?: 'PullFacilityResponse', readonly documents: ReadonlyArray<{ readonly __typename?: 'SyncableFacility', readonly id: string, readonly name: string, readonly organisation: string, readonly service?: string | null, readonly addresses: ReadonlyArray<{ readonly __typename?: 'Address', readonly country?: string | null, readonly state?: string | null, readonly street?: string | null, readonly subCounty?: string | null, readonly ward?: string | null }>, readonly settings: { readonly __typename?: 'ClinicSettings', readonly inventoryManagement: boolean }, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly updatedAt: string, readonly createdByUserId: string, readonly updatedByUserId: string, readonly deleted: boolean } }> } };

export const WholeSyncableFacilityFragmentDoc = gql`
    fragment WholeSyncableFacility on SyncableFacility {
  id
  name
  addresses {
    country
    state
    street
    subCounty
    ward
  }
  organisation
  service
  settings {
    inventoryManagement
  }
  meta {
    createdAt
    updatedAt
    createdByUserId
    updatedByUserId
    deleted
  }
}
    `;
export const SyncFacilityPullDocument = gql`
    query SyncFacilityPull($input: PullFacilityInput!) {
  pullFacility(input: $input) {
    documents {
      ...WholeSyncableFacility
    }
  }
}
    ${WholeSyncableFacilityFragmentDoc}`;

/**
 * __useSyncFacilityPullQuery__
 *
 * To run a query within a React component, call `useSyncFacilityPullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSyncFacilityPullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSyncFacilityPullQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncFacilityPullQuery(baseOptions: Apollo.QueryHookOptions<SyncFacilityPullQuery, SyncFacilityPullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SyncFacilityPullQuery, SyncFacilityPullQueryVariables>(SyncFacilityPullDocument, options);
      }
export function useSyncFacilityPullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SyncFacilityPullQuery, SyncFacilityPullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SyncFacilityPullQuery, SyncFacilityPullQueryVariables>(SyncFacilityPullDocument, options);
        }
export type SyncFacilityPullQueryHookResult = ReturnType<typeof useSyncFacilityPullQuery>;
export type SyncFacilityPullLazyQueryHookResult = ReturnType<typeof useSyncFacilityPullLazyQuery>;
export type SyncFacilityPullQueryResult = Apollo.QueryResult<SyncFacilityPullQuery, SyncFacilityPullQueryVariables>;